import React, {
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { Box, styled } from "@mui/material";
import { EnvironmentRegistry } from "../../services/registry/environmentRegistry";
import { getIframeToken } from "../../services/userOnboardService/userOnboardService";
import { Loader } from "../../components/loader/Loader";
// import ReloadButton from "../salescodeStudio/mandatoryConfigs/uiThemeConfig/widgets/reloadButton";
import { PlaygroundConfigValueContext } from "../../components/newPortal/NewPortalLayout";
import { useSelector } from "react-redux";
import store from "../../stateManagement/store";
import { getMetaDataConfig } from "../../services/uiConfigService";
import { getConfigFromClientConfig } from "../../services/bannerServices";

interface PhoneFrameProps {
  widthValue?: string;
  heightValue?: string;
}

const PhoneFrame = styled(Box)<PhoneFrameProps>(
  ({ widthValue, heightValue }) => ({
    width: widthValue || "60%", // default to "60%" if widthValue is not provided
    minWidth: "200px",
    height: heightValue || "110%",
    minHeight: "400px",
    borderRadius: 30,
    boxShadow: "0 10px 20px rgba(0, 0, 0, 0.2)",
    position: "relative",
    outline: "5px solid black",
    overflow: "clip",
  })
);

const PhoneScreen = styled(Box)({
  width: "100%",
  height: "100%",
  backgroundColor: "white",
  borderRadius: 20,
  overflow: "hidden",
});

interface IPhoneFrameComponent {
  allowTriggerChanges?: boolean;
  widthValue?: string;
  heightValue?: string;
  playgroundConfiguration?: any[],
  setPlayGroundConfiguration?: React.Dispatch<React.SetStateAction<any[]>>;
  onTriggerConfigChanges?: () => void;
  setKeyValue?:React.Dispatch<React.SetStateAction<number>>;
  keyValue?:number
  cleanSyncDataLoaderIds?:string[]
  setCleanSyncDataLoaderIds?:React.Dispatch<React.SetStateAction<string[]>>
}

const PhoneFrameComponent = (props: IPhoneFrameComponent) => {
  const PlaygroundConfigContext = useContext(PlaygroundConfigValueContext);
  const {
    playgroundConfiguration,
    setPlayGroundConfiguration,
    onTriggerConfigChanges,
    cleanSyncDataLoaderIds,
    setCleanSyncDataLoaderIds,
    keyValue,
    setKeyValue,
  } = PlaygroundConfigContext ?? {
    playgroundConfiguration: props.playgroundConfiguration,
    setPlayGroundConfiguration: props.setPlayGroundConfiguration,
    onTriggerConfigChanges: props.onTriggerConfigChanges,
    keyValue:props.keyValue,
    setKeyValue:props.setKeyValue,
    cleanSyncDataLoaderIds:props.cleanSyncDataLoaderIds,
    setCleanSyncDataLoaderIds:props.setCleanSyncDataLoaderIds
  };
  const lob = EnvironmentRegistry.getCurrentLob();
  const [loading, setLoading] = useState(false);
  const [accessToken, setAccessToken] = useState<string | null>(null);
  const [refreshCount, setRefreshCount] = useState(0);
  const savedRole:any = useSelector(() => store.getState().roleState.role)

  const getToken = useCallback(async () => {
    setLoading(true);
    const token = await getIframeToken(savedRole.id);
    setAccessToken(token);
    setLoading(false);
  }, [savedRole]);

  useEffect(() => {
    getToken();
  }, [getToken]);
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const updateSize = () => {
      // debugger;
      // Get parent container height in px
      const container = document.getElementById("phone-wrapper");
      if (!container) return;

      const height = container.offsetHeight ;  
      const ratio = 355/711; // width/height for 19.5:9
      const width = height * ratio;
      setDimensions({ width, height });
    };

    updateSize();
    window.addEventListener("resize", updateSize);

    return () => window.removeEventListener("resize", updateSize);
  }, []);
  const frameComponent = (
    <PhoneFrame 
    style={{
      width: props.widthValue ?? `${dimensions.width}px`,
      height: props.heightValue ?? `${dimensions.height}px`,
      borderRadius: "30px",
      margin: "0 auto",
      overflow: "hidden",
    }}
    >
      <PhoneScreen>
        {!loading ? (
          <iframe
            key={keyValue}
            // src={`https://${lob}.salescode.ai?playground=true&token=${accessToken}`}
            src={`https://${lob}.salescode.ai/${
              [
                accessToken ? `playground=true&token=${accessToken}` : null,
                cleanSyncDataLoaderIds?.length
                  ? `cleanSyncDataLoaderIds=${cleanSyncDataLoaderIds.join(",")}`
                  : null,
                
              ]
                .filter(Boolean)
                .join("&")
                .replace(/^/, "?")
            }`}
            title="Salescode AI"
            style={{ width: "100%", height: "100%", border: "none" }}
          ></iframe>
        ) : (
          <Loader />
        )}
      </PhoneScreen>
    </PhoneFrame>
  );

  return props.allowTriggerChanges ? (
    <>
      <Suspense fallback={<Loader />}>{frameComponent}</Suspense>
    </>
  ) : (
    frameComponent
  );
};

export default PhoneFrameComponent;
